import {
    GETMERCHANTCHARGELIST_SUCCESS,
    GETMERCHANTCHARGELIST_FAILED,
    RESET_GETMERCHANTCHARGELIST,
    LOADING_GETMERCHANTCHARGELIST,
    NETWORK_ERROR_GETMERCHANTCHARGELIST
} from "../types/index";

const initialState = {
    isLoading: false,
    success: false,
    network: false,
    failed: false,
    data: {}
};

export default (state = initialState, action) => {
    switch (action.type) {
        case LOADING_GETMERCHANTCHARGELIST:
            return {
                ...state,
                isLoading: true,
                success: false,
                failed: false,
                network: false,
                data: {}
            };
        case GETMERCHANTCHARGELIST_FAILED:
            return {
                ...state,
                isLoading: false,
                success: false,
                failed: true,
                network: false,
                data: action.payload
            };
        case GETMERCHANTCHARGELIST_SUCCESS:
            return {
                ...state,
                isLoading: false,
                success: true,
                failed: false,
                network: false,
                data: action.payload
            };
        case NETWORK_ERROR_GETMERCHANTCHARGELIST:
            return {
                ...state,
                isLoading: false,
                success: false,
                failed: false,
                network: true,
                data: {}
            };
        case RESET_GETMERCHANTCHARGELIST:
            return (state = initialState);
        default:
            return state;
    }
};
